import React, {memo} from 'react';
import cn from 'classnames';
import {WindDirection} from '@/app/interfaces/weather';
import {SpeedUnit} from '@/common/constants/units';
import {useLocalizer} from '@/common/services/localizer';
import {Tooltip} from '@/common/components/Tooltip';
import styles from './WindIcon.css';

interface WindIconProps {
	className?: string;
	speed: number;
	speedUnit: SpeedUnit;
	direction?: WindDirection;
}

export const WindIcon = memo<WindIconProps>(props => {
	const {className, speed, speedUnit, direction} = props;

	const t = useLocalizer();

	return (
		<Tooltip
			className={cn(styles.root, !speed && styles.isCalm, styles[`to${direction}`], className)}
			title={`${t(`windDirections.${direction || 'calm'}`)}, ${speed} ${t(`unitAbbr.speed.${speedUnit}`)}`}
			aria-label={t(`windDirections.${direction || 'calm'}`)}
			positionX='middle'
		/>
	);
});

WindIcon.displayName = 'WindIcon';
